export enum RouteName {
  List = 'transaction-list',
}
